module.exports = __webpack_public_path__ + "static/img/yahong_icon.d6a6021.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/yahong_icon.png
// module id = EbEd
// module chunks = 1